import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { debounceTime } from 'rxjs';
import { FileService } from '../../../core/api/file.service';
import { ReimburseService } from '../../../core/api/reimburse.service';
import { BasePageComponent } from '../../../core/classes/base-page';
import { AuthService } from '../../../core/services/auth.service';
import { HelpersService } from '../../../core/services/helpers.service';
import { LoadingService } from '../../../core/services/loading.service';
import { CheckSelect } from '../../../core/classes/check-select';
import { FilePreviewComponent } from '../../../components/file-preview/file-preview.component';

@Component({
  selector: 'app-reimbursement-approval',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    RouterModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './reimbursement-approval.component.html',
  styleUrl: './reimbursement-approval.component.scss',
})
export class ReimbursementApprovalComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();
  counter: any = {
    all: 0,
    draft: 0,
    sent: 0,
    approved: 0,
    reimbursed: 0,
    rejected: 0,
  };
  currentFilter: any;

  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: ReimburseService,
    public override authService: AuthService,
    private fileService: FileService
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService
    );
    this.displayedColumns = [
      'no',
      'refId',
      'title',
      'file',
      'expanse_category',
      'status',
      'date',
      'amount',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
    this.subject = 'refId';
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.loading.startLoading();
    this.service.getCountStatusApproval().then(
      (res) => {
        this.counter = res;
        this.counter.all = 0;
        Object.keys(this.counter).forEach((i: any) => {
          if (i != 'all') {
            this.counter.all += this.counter[i];
          }
        });
        this.loading.endLoading();
      },
      (error) => {
        this.loading.endLoading();
        this.helpers.sbError(error.message);
      }
    );

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  override afterInit(): void {
    if (!this.data) this.loading.startLoading();
    this.service.getAllApprove(this.authService.isSysAdmin(this.currentUser) ? null : this.currentUser.id, this.q).then(
      (data) => {
        this.data = data;
        this.dataSource = new MatTableDataSource(data);
        this.select = new CheckSelect(this.dataSource, this.selection);
        this.afterGetData();
        this.loading.endLoading();
      },
      (error) => {
        this.loading.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  override getData(): void {
    this.loading.startLoading();
    this.service
      .getAllApprove(this.currentUser.id, this.q)
      .then((data) => {
        this.assignData(data);
        this.afterGetData();
        this.loading.endLoading();
      })
      .catch((err) => {
        this.helpers.sbError(err);
        this.loading.endLoading();
      });
  }

  detailReimburse(id: any) {
    this.router.navigate(['/dashboard/reimbursement-approval/action'], {
      queryParams: {
        m: 'detail',
        id,
      },
    });
  }

  download(item: any) {
    const targetFile = this.helpers.resolveTargetFile(item);
    if (targetFile?.id) {
      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: targetFile,
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  changeFilter(filter: any): void {
    if (this.currentFilter === filter || filter == null) {
      this.currentFilter = null;
    } else {
      this.currentFilter = filter;
    }
    this.q.status = this.currentFilter;
    this.getData();
  }

  override onSortChange(sort: Sort): void {
    const { active, direction } = sort;
    this.sortActive = active;
    this.sortDirection = direction || 'desc';
    this.q.sortBy = this.sortActive;
    this.q.sortDir = this.sortDirection;
    this.getData();
  }

}
